export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateName = (name) => {
  const nameRegex = /^(?=.*\s)(?!.*\s{2})[a-zA-Z\s]{2,}$/;
  return nameRegex.test(name);
};
